$(function(){
	var iframe = $(".adjust_iframe");

	// Adjusting the iframe height onload event
	iframe.each(function() {
		this.onload = function(){
			this.style.height = this.contentWindow.document.body.scrollHeight + 'px';
		};
	});

	setInterval(function(){
		iframe.each(function() {
			this.style.height = this.contentWindow.document.body.scrollHeight + 'px';
		});
	}, 500);

})
